


import React, { useState } from 'react';

const CPDForm = ({ addCPDRecord }) => {
  const [formData, setFormData] = useState({
    title: '',
    duration: '',
    venue: '',
    organizedBy: '',
    conductedBy: '',
    cpdType: 'short courses', // Default value
 
    startDate: '', // New start date field
    endDate: '', // New end date field
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    addCPDRecord(formData);
    setFormData({
      title: '',
      duration: '',
      venue: '',
      organizedBy: '',
      conductedBy: '',
      cpdType: 'short courses',
    
      startDate: '', // Reset start date
      endDate: '', // Reset end date
    });
  };

  return (
    <form onSubmit={handleSubmit} className="container">
      <h2>Continuing Professional Development(CPD) <br/>Activity Tracker</h2>
      <label>Title</label>
      <input
        type="text"
        name="title"
        placeholder="Electronics Circuit Design Training"
        value={formData.title}
        onChange={handleChange}
        required
      />
      <label>Duration</label>
      <input
        type="number"
        name="duration"
        placeholder="Duration (in hours)"
        value={formData.duration}
        onChange={handleChange}
        required
      />
      <label>Venue</label>

      <input
        type="text"
        name="venue"
        placeholder="Venue"
        value={formData.venue}
        onChange={handleChange}
        required
      />
      <label>Organized By</label>

      <input
        type="text"
        name="organizedBy"
        placeholder="Organized By"
        value={formData.organizedBy}
        onChange={handleChange}
        required
      />
        <label>Conducted By</label>
      <input
        type="text"
        name="conductedBy"
        placeholder="Conducted By"
        value={formData.conductedBy}
        onChange={handleChange}
        required
      />
        <label>Start Date</label>
      <input
        type="date" // Start date input
        name="startDate"
      
        value={formData.startDate}
        onChange={handleChange}
        required
      />
        <label>End Date (Optional)</label>
      <input
        type="date" // End date input
        name="endDate"
        value={formData.endDate}
        onChange={handleChange}
        
      />
              <label>CPD Type</label>

      <select name="cpdType" value={formData.cpdType} onChange={handleChange} required>
        <option value="short courses">Short Courses</option>
        <option value="private study and research">Private Study and Research</option>
        <option value="workshops/seminars">Workshops/Seminars</option>
        <option value="post graduate course">Post Graduate Course</option>
        <option value="volunteering">Volunteering</option>
        <option value="serving on technical committees">Serving on Technical Committees</option>
        <option value="publishing technical papers or articles">Publishing Technical Papers or Articles</option>
        <option value="on-the-job training">On-the-Job Training</option>
      </select>
      <button type="submit">Add Activity</button>
    </form>
  );
};

export default CPDForm;